import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export const proDriverAgreementListQuery = graphql(`
  query ProDriverAgreementList($work_order_assignment_id: ID) {
    proDriverAgreements(work_order_assignment_id: $work_order_assignment_id) {
      id
      uuid
      title
      body
      status
      sent_at
      viewed_at
      signed_at
      declined_at
      voided_at
      decline_reason
      signer_name
      created_at
      template {
        id
        name
      }
      pdf {
        ...MediaFields
      }
      signedPdf {
        ...MediaFields
      }
    }
  }
`);

export type ProDriverAgreementRecord = ResultOf<
  typeof proDriverAgreementListQuery
>["proDriverAgreements"][number];

export const proDriverAgreementRecordQuery = graphql(`
  query ProDriverAgreementRecord($id: ID!) {
    proDriverAgreement(id: $id) {
      id
      uuid
      title
      body
      status
      sent_at
      viewed_at
      signed_at
      declined_at
      voided_at
      decline_reason
      signer_name
      work_order_assignment_id
      template {
        id
        name
      }
      pdf {
        ...MediaFields
      }
      signedPdf {
        ...MediaFields
      }
      workOrderAssignment {
        id
        proDriver {
          id
          name
        }
        workOrder {
          id
          reference
        }
      }
    }
  }
`);

export type ProDriverAgreementRecordDetail = NonNullable<
  ResultOf<typeof proDriverAgreementRecordQuery>["proDriverAgreement"]
>;

export const proDriverAgreementPreviewQuery = graphql(`
  query ProDriverAgreementPreview($input: ProDriverAgreementPreviewInput!) {
    proDriverAgreementPreview(input: $input)
  }
`);
